// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientPaymentPage_container__1J-2q"};